import * as React from "react";
import type { SVGProps } from "react";
const SvgLuggageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#000" clipPath="url(#luggage-check_svg__a)">
      <path d="M11 16h-.01c-.33 0-.64-.17-.82-.45l-2-3a1.001 1.001 0 1 1 1.67-1.11l1.19 1.78 6.15-8.79c.32-.45.94-.56 1.39-.25s.56.94.25 1.39l-7 10c-.19.27-.49.43-.82.43" />
      <path d="M15.34 22H6.66C5.2 22 4 20.81 4 19.34V8.66C4 7.2 5.19 6 6.66 6H13c.55 0 1 .45 1 1s-.45 1-1 1H6.66a.66.66 0 0 0-.66.66v10.69c0 .36.29.66.66.66h8.68c.36 0 .66-.29.66-.66v-7.36c0-.55.45-1 1-1s1 .45 1 1v7.36c0 1.46-1.19 2.66-2.66 2.66z" />
      <path d="M13 7.79c-.55 0-1-.45-1-1V2h-2v4.79c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5.79c0 .55-.45 1-1 1M8 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1M14 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="luggage-check_svg__a">
        <path fill="#fff" d="M4 0h15v24H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLuggageCheck;
